module.exports = __webpack_public_path__ + "img/content6-5.39cc53bb.webp";